import { lazy } from 'react';


export const InfoAboutDevs = lazy(() => import('./InfoAboutDevs'));
